import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ApiService } from 'src/services/apiService';
import { AuthService } from 'src/services/auth.service';
import { SweetAlertService } from 'src/services/sweetAlertService';
import jwt_decode from "jwt-decode";
import { CookieService } from 'ngx-cookie-service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from 'src/services/localStorageService.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';


@Component({
  selector: 'app-login-investment',
  templateUrl: './login-investment.component.html',
  styleUrls: ['./login-investment.component.scss']
})
export class LoginInvestmentComponent {

  @ViewChild('myForm', { static: true }) myForm: NgForm | undefined;

  username: string | undefined;
  password: string | undefined;
  isLoading = false;
  lang: string;
  isProdction = false;
  mainPath = "" // قراءة القيمة من environment
  logoPicSrc = "" // قراءة القيمة من environment
  backGroundImageSrc = "" // قراءة القيمة من environment

  constructor(private apiService: ApiService,
    private sweetAlertService: SweetAlertService,
    private authService: AuthService,
    private cookieService: CookieService,
    private translate: TranslateService,
    private localStorageService: LocalStorageService,
  ) {
    this.lang = cookieService.get('lang');
    this.isProdction = environment.production;
    this.mainPath = environment.MainPath;
    this.logoPicSrc = environment.LogoPicSrc;
    this.backGroundImageSrc = environment.backGroundImageSrc;
    this.localStorageService.clearAllCookies();
  }

  changeLanguage() {

    this.lang == "ar" ? this.lang = "en" : this.lang = "ar";

    this.translate.use(this.lang);
    this.cookieService.set('lang', this.lang);

    setTimeout(() => {
      location.reload();
    }, 500);
  }

  registerSabad() {
    this.sweetAlertService.ShowAlert('info', "يرجى انشاء حساب على تطبيق سند");
  }

  login() {

    if (!this.myForm?.valid) return;

    this.isLoading = true;

   this.doLogin();

  }


  private doLogin() {
    const body = {
      userName: this.username!.toString(),
      password: this.password!,
      deviceToken: '',
    };


    if (this.mainPath == "HCD") {

       this.apiService.post('auth/Loginbyidm', body).subscribe({
      next: (response: any) => {
        if (response.statusCode === 200) {
             
          const data = response.data;
 let role: string;
 this.authService.setNationalNumber(this.username!);

        
            this.cookieService.set('lgoinBy','IDM');
            role = 'CONSUMER' 
            location.href = '/' + this.mainPath + '/Otp';
         

        
          this.authService.setToken(data.access_token);
          this.authService.setRefreshToken(data.refresh_token);
          

          const decoded = jwt_decode(data.access_token) as any;
         
           role = decoded.role;
       
          const name = this.authService.getNationalNumber();

          debugger;
          // your routing logic
          if (this.mainPath=="HCD") {
            role = 'CONSUMER' 
            location.href = '/' + this.mainPath + '/Dashboard';
          }
      

          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.sweetAlertService.ShowAlert('error', response.message);
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error(err);
        this.sweetAlertService.ShowAlert('error', 'Login failed.');
      }
    });
      
    }

    else{
     debugger;
    this.apiService.post('auth/Login', body).subscribe({
      next: (response: any) => {
        if (response.statusCode === 200) {
             ;
          const data = response.data;
 let role: string;
 this.authService.setNationalNumber(this.username!);
          //  if (data.access_token =="") {
          //   this.cookieService.set('lgoinBy','IDM');
          //   role = 'CONSUMER' 
          //   location.href = '/' + this.mainPath + '/Otp';
          //   return;
          // }

          this.cookieService.set('lgoinBy','Govnet');
          this.authService.setToken(data.access_token);
          this.authService.setRefreshToken(data.refresh_token);
          

          const decoded = jwt_decode(data.access_token) as any;
         
           role = decoded.role;
       
          const name = this.authService.getNationalNumber();

          // your routing logic
       if (role === 'CONSUMER') {
            location.href = '/' + this.mainPath + '/Dashboard';
          } else if (role?.includes('ADMIN_ENTITY') && role?.includes('MANAGER') && name?.toLocaleLowerCase() === 'mohammed.al-omari@moin.gov.jo') {
            location.href = '/' + this.mainPath + '/ControlPanel/add-exemption-book';
          } else if (role?.includes('PROVIDER') && role?.includes('HDRDA_MOIN')) {
            location.href = '/' + this.mainPath + '/ControlPanel/manage-company';
          } else if (role?.includes('PROVIDER') && role?.includes('HEID_MOIN')) {
            location.href = '/' + this.mainPath + '/ControlPanel/Exemptions';
          } else if (role?.includes('PROVIDER') && role?.includes('FO_MOIN')) {
            location.href = '/' + this.mainPath + '/ControlPanel/Recipt';
          } else if (role?.includes('PROVIDER') && role?.includes('DSAD_OFDC')) {
            location.href = 'ControlPanel/Reject';
          } else if (role?.includes('PROVIDER') && role?.includes('DPID_MPWH')) {
            location.href = '/' + this.mainPath + '/Engineer';
          }
          else if (role?.includes('PROVIDER') && role?.includes('DCEPA_HCD') ) {
               location.href = '/' + this.mainPath + '/disability';
          }

          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.sweetAlertService.ShowAlert('error', response.message);
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error(err);
        this.sweetAlertService.ShowAlert('error', 'Login failed.');
      }
    });
  }}



}
